var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('route-list-data-table',{attrs:{"title":"On Delivery","defaultSortField":"on_delivery_at","defaultSortOrder":"dsc","myRoutes":true,"headers":_vm.headers,"status":_vm.status,"assocs":_vm.assocs,"routeClickGoTo":"route-info"}})}
var staticRenderFns = []

export { render, staticRenderFns }